import { useSelector } from "react-redux"

const AdminDashboard = () => {

    const profile = useSelector(state => state.auth.profile);
    
    return (
        <>
            {/* بخش سلام و اطلاعات کاربر */}
            <div>
                <h2 className="text-xl font-bold text-slate-800">
                    سلام {profile?.firstName || "کاربر عزیز"} 👋
                </h2>
                <p className="text-sm text-slate-500 mt-1">
                    امروز می‌خواهید چه کاری انجام دهید؟
                </p>
            </div>
        </>
    )

}

export default AdminDashboard